import SkeletonTable from "@/components/SkeletonTable"
import api from "@/lib/axios"
import { useQuery } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import { DataTable } from "./partial/DataTable"
import { columns } from "./partial/Columns"

const getListKelompokVerifikasiPesertaKepemimpinan = async (
  id_verkepemimpinan_rekap: string
) => {
  const response = await api.get(
    `/setting/verifikator-kepemimpinan/show-kelompok/${id_verkepemimpinan_rekap}`,
    {
      withCredentials: true,
    }
  )
  return response.data
}

export default function SettingVerifikatorKepemimpinanDetailPage() {
  const [searchParams] = useSearchParams()
  const idVerKepemimpinanRekap = searchParams.get("id")

  const { data, isPending } = useQuery({
    queryKey: ["listKelompokVerifikasiKepemimpinan", idVerKepemimpinanRekap],
    queryFn: () =>
      getListKelompokVerifikasiPesertaKepemimpinan(String(idVerKepemimpinanRekap)),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  )
}
